import React from 'react'
import { DEFAULT_CURRENCY_CODE, PRODUCT_IMAGE_URL, SLASH } from 'lib/core/resources/constants'
import { Price } from 'lib/shared/components'
import { VisitureOrderItem } from 'lib/core/data/customer/orders/types'

interface Props {
  item: VisitureOrderItem
}

export const ProductItem: React.FC<Props> = ({ item }) => {
  const {
    sku,
    price,
    qty,
    thumbnail,
    name,
    options
  } = item

  const imageUrl = `${PRODUCT_IMAGE_URL}${SLASH}${thumbnail}` // TODO: do not use PRODUCT_IMAGE_URL
  const priceNumber = parseFloat(price)
  return (
    <div
      key={sku}
      className='order__content'
    >
      <div className='order__item'>
        <div className='item__image'>
          <span
            style={{ backgroundImage: `url(${imageUrl})` }}
          />
        </div>
        <div className='item__info'>
          <div className='name'>
            {name}
          </div>
          <div>
            {options?.map((option: { value: React.ReactNode }, index: number) => {
              return <span key={index}>{option.value}</span>
            })}
          </div>
          <div>
            Qty: <strong>{parseInt(qty)}</strong>
          </div>
        </div>
        <div className='item__price'>
          <Price
            value={priceNumber * parseInt(qty)}
            currency={DEFAULT_CURRENCY_CODE}
          />
        </div>
      </div>
    </div>
  )
}
